import {
	type FieldValues,
	type Path,
	type UseFormSetError,
	useFormContext,
} from "react-hook-form";

const errorMap = {
	EMAIL_NOT_VERIFIED: {
		path: "email",
		message:
			"Email not verified. Please check your email for the verification link.",
	},
	INVALID_EMAIL_OR_PASSWORD: {
		path: "email",
		message: "Invalid email or password.",
	},
	USER_ALREADY_EXISTS_USE_ANOTHER_EMAIL: {
		path: "email",
		message: "Email is already in use. Please use another email.",
	},
} as const;

export function useBetterAuthError<TSchema extends FieldValues>() {
	const { setError } = useFormContext<TSchema>();
	return { setBetterAuthError: setBetterAuthError(setError) };
}

export function setBetterAuthError<TSchema extends FieldValues>(
	setError: UseFormSetError<TSchema>,
) {
	return (code: keyof typeof errorMap) => {
		if (!errorMap[code]) {
			setError("root", {
				type: "manual",
				message: "Something went wrong. Please try again.",
			});
			return;
		}

		setError(errorMap[code].path as Path<TSchema>, {
			type: "manual",
			message: errorMap[code].message,
		});
	};
}
